/**
 * @fileoverview POST handler for the "/integrations/scim/scim_destroy" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { integrationsScimScimDestroyCacheKeys } from "./constants";
import type { PostIntegrationsScimScimDestroyProps, IntegrationsScimScimDestroyResult } from "./types";

export const postIntegrationsScimScimDestroy = reactQueryMutationAdapter(
  integrationsScimScimDestroyCacheKeys,
  (props: PostIntegrationsScimScimDestroyProps): Promise<IntegrationsScimScimDestroyResult> => {
    // manipulate props here as needed idp

    return fetch("/integrations/scim/scim_destroy", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
